// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://rsms.me/inter/inter.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
  Takes a css-key, an optional css-value and a theme-value
  usage : theme("box-shadow", 0 0 30px 5px, "primary") => box-shadow: 0 0 30px 5px primary,
  theme("color", "primary") => color: primary
 */
/* stylelint-disable */
.categoryFilter {
  margin-top: 30px;
  padding-right: 50px;
}

.segmentedControl {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: baseline;
  margin-top: 30px;
  margin-right: 50px;
  padding-right: 20px;
  padding-left: 12px;
}

.dateFilter {
  display: flex;
  gap: 16px;
  align-items: center;
}

.dateFilterDisabled {
  opacity: 0.6;
  pointer-events: none;
}

.dateFilterLabel {
  font-family: "Lato", sans-serif;
}

.dateInputWrapper {
  display: flex;
  gap: 16px;
  align-items: center;
}

.genderFilter {
  margin-top: 20px;
  padding-right: 50px;
  padding-left: 12px;
}

.calendarDropdown.calendarDropdown {
  z-index: 5;
  padding: 0;
  background-color: transparent;
  box-shadow: unset;
}

.error-template {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5em;
  margin-bottom: 1em;
}
.error-template .error-number {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  font-size: 42px;
}
.error-template .error-number.has-technis-logo {
  max-width: 12em;
}
.error-template .error-number:not(.has-technis-logo) {
  line-height: 0.8;
}
.error-template .error-number .technis-logo {
  width: 40%;
  height: 40%;
}
.error-template .error-number .normal-error-code {
  font-size: 120px;
}
.error-template .error-message {
  margin: 1em 0;
  font-weight: 300;
  font-size: 28px;
  text-align: center;
}
.error-template .buttons button:not(:last-child) {
  margin-right: 0.5em;
}

.tooltip-bold {
  font-weight: 700;
}

.widgetWrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.tooltipWrapper p {
  margin: 0;
}

.tooltipContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.widget {
  position: relative;
  width: 100%;
  border-radius: 12px;
}
.widget__export {
  position: absolute;
  top: 0;
  right: 30px;
  margin-top: 15px;
  margin-bottom: 15px;
}
.widget__export p {
  margin: 0;
}
.widget__image {
  width: 26px;
  height: 26px;
  cursor: pointer;
}
.widget__loader {
  padding: 30px;
  text-align: center;
}
.widget__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.widget .widget__title {
  display: flex;
  margin: 0;
  font-weight: bold;
}
.widget .mapView-container {
  margin-top: 15px;
}
.widget .mapView-container .dropdown {
  max-width: 200px;
  margin-bottom: 15px;
}
.widget .mapView-container label {
  font-size: 12px;
}
.dark .widget .mapView-container label {
  color: #3c3c3b;
}
.light .widget .mapView-container label {
  color: #3c3c3b;
}
.widget .heatmap {
  display: block;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.widget .heatmap__image {
  max-width: 100%;
}
.widget .heatmap__carousel {
  width: 100%;
}
.widget .heatmap .dropdown {
  max-width: 200px;
  margin: 15px 0;
  text-align: left;
}

.widgetTitleWrapper {
  display: flex;
}

.tooltipWrapper {
  position: relative;
  top: 1px;
  margin-left: 5px;
}

.kpiCardWrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.kpiCardWrapper .kpiSubTitle {
  margin-top: 30px;
  font-weight: 800;
  font-size: 24px;
}
.kpiCardWrapper .kpiCardContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(254px, 1fr));
  gap: 16px;
  width: 100%;
}
.kpiCardWrapper .kpiCardContainer .kpiCard {
  height: 180px;
  min-width: 170px;
  max-width: 218px;
  margin: 10px 26px;
  border-radius: 12px !important;
}
.kpiCardWrapper .kpiCardContainer .kpiCard .kpiFirstLine {
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 24px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
}
.kpiCardWrapper .kpiCardContainer .kpiCard .kpiFirstLine > div,
.kpiCardWrapper .kpiCardContainer .kpiCard .kpiFirstLine [data-for] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.kpiCardWrapper .kpiCardContainer .kpiCard .kpiFirstLine svg {
  flex: 0 0 32px;
}
.kpiCardWrapper .kpiCardContainer .kpiCard .kpiSecondLine {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 15px;
  margin-top: 52px;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
}

.table-graph-container {
  padding: 5px 10px 0 10px;
}
.table-graph-container .table-line {
  margin-bottom: 20px;
  border: 1px solid;
}
.table-graph-container .table-graph-head {
  border: none;
}
.table-graph-container .table-header {
  border: none;
}
.table-graph-container .table-header td:first-child {
  min-width: 230px;
  padding-left: 25px;
  border-radius: 12px 0 0 12px;
}
.table-graph-container .table-header td:last-child {
  border-radius: 0 12px 12px 0;
}
.table-graph-container .table-header div {
  font-weight: 600;
  line-height: 22px;
}
.table-graph-container .table-row {
  font-weight: 500;
  font-size: 18px;
  line-height: 19px;
}
.table-graph-container .table-row tr:first-child {
  border: none;
}
.table-graph-container .table-row td:first-child {
  border-radius: 12px 0 0 12px;
}
.table-graph-container .table-row td:last-child {
  border-radius: 0 12px 12px 0;
}

.widget__loader--table {
  padding: 6px 30px 30px;
}
.widget__loader--pie {
  padding: 40px 30px 20px;
}
.widget__loader--chart {
  padding: 30px 30px 20px;
}
.widget__loader--no-pad {
  padding: 0px;
}
.widget__loader--grid-map {
  padding: 29px 9px;
}

.kpiCardSkeletonContainer {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(254px, 1fr));
  gap: 16px;
  width: 100%;
}
.kpiCardSkeletonContainer .skeletonKpi {
  border-radius: 12px !important;
}

.skeletonTableWrapper {
  margin-left: 8px;
}
.skeletonTableWrapper .skeletonTableLine {
  border: 1px solid;
}
.skeletonTableWrapper .skeletonTableHeaderWrapper {
  margin-top: 22px;
}
.skeletonTableWrapper .skeletonTableHeader {
  border-radius: 12px !important;
}
.skeletonTableWrapper .skeletonTableRowWrapper {
  margin-bottom: -25px;
}
.skeletonTableWrapper .skeletonTableRow {
  margin-top: 7px;
}

.skeletonWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.chartSkeletonWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.chartSkeletonWrapper .legendGradientContainer {
  margin-top: 35px;
  margin-bottom: 13px;
}
.chartSkeletonWrapper .chartSkeletonContainer {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.chartSkeletonWrapper .chartSkeletonContainer .chartItem {
  margin: 2px;
}

.skeletonMapViewWrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.skeletonMapViewWrapper .skeletonLinesWrapper {
  width: 100%;
}
.skeletonMapViewWrapper .skeletonLinesWrapper span {
  margin: 10px 0px 10px 30px;
  border-radius: 50px;
}

.skeletonPieChart {
  margin-bottom: 30px;
}

.skeletonLineAreaChart {
  margin-bottom: 35px;
}

.legend {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.legend .legendItem {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.legend .legendItem span {
  border-radius: 50px;
}
.legend .legendItem .legendCircle {
  margin-right: 10px;
}
.legend .legendItem .legendText {
  margin-right: 25px;
}
.legend .legendItem .legendGradient {
  border-radius: 0px;
}

.report-card .report-card-title {
  margin: 0;
  padding-top: 5px;
  font-weight: 700;
  font-size: 36px;
  font-style: normal;
  line-height: 44px;
  letter-spacing: 0;
  text-align: center;
}
.dark .report-card .report-card-title {
  color: #4153af;
}
.light .report-card .report-card-title {
  color: #4153af;
}
.report-card .report-card-line {
  top: 592px;
  left: 421px;
  width: 837px;
  height: 0;
  margin-top: 18px;
  border: 1px solid;
}
.dark .report-card .report-card-line {
  border-color: rgba(60, 60, 59, 0.1);
}
.light .report-card .report-card-line {
  border-color: rgba(60, 60, 59, 0.1);
}
.report-card .report-card-subtext {
  margin-top: 10px;
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  line-height: 14px;
  letter-spacing: 0;
  text-align: center;
}
.dark .report-card .report-card-subtext {
  color: #bbbdc6;
}
.light .report-card .report-card-subtext {
  color: #bbbdc6;
}
.report-card .report-card-form-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 36px;
}
.report-card .report-card-form-block {
  width: 40%;
  padding: 0 22px 32px;
  box-sizing: border-box;
}
.report-card .report-card-form-block .report-card-form-emails {
  margin-top: 40px;
}
.report-card .report-card-bottom-subtitle {
  margin-top: 30px;
  text-align: center;
}
.report-card .report-card-button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 33px;
}
.report-card .report-card-button-wrapper .report-card-button {
  width: 140px;
  height: 34px;
  border-radius: 8px;
}
.dark .report-card .report-card-button-wrapper .report-card-button {
  background-color: #588de7;
}
.light .report-card .report-card-button-wrapper .report-card-button {
  background-color: #588de7;
}
.report-card .dropdown-wrapper {
  padding: 3px;
}
.report-card .dropdown-wrapper .Dropdown__value-container {
  margin-bottom: -15px;
}
.report-card .dropdown-wrapper .Dropdown__single-value {
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
}
.report-card .dropdown-wrapper .Dropdown__indicator {
  margin-right: -5px;
  margin-bottom: -10px;
}
.report-card .dropdown-wrapper .Dropdown__indicator-separator {
  display: none;
}
.report-card .dropdown-wrapper .Dropdown__control {
  margin-top: -8px;
  margin-bottom: 8px;
}
.report-card .card-wrapper {
  padding-right: 20px;
  border: 1px solid;
  border-radius: 12px;
  box-shadow: none;
}
.dark .report-card .card-wrapper {
  border-color: rgba(60, 60, 59, 0.1);
}
.light .report-card .card-wrapper {
  border-color: rgba(60, 60, 59, 0.1);
}
.report-card .card-wrapper h3 {
  font-size: 14px;
}

.errorBoundary {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
.errorBoundary--buttons {
  display: flex;
  align-items: center;
}
.errorBoundary--buttons button {
  margin: 15px;
}
.errorBoundary h1 {
  margin-bottom: 50px;
}

.cookiesModal {
  position: absolute;
  bottom: 24px;
  right: 24px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  width: 535px;
  padding: 32px 48px;
  border-radius: 10px;
  box-shadow: 2px 2px 20px rgba(115, 115, 115, 0.1), 2px 10px 50px 3px rgba(112, 112, 224, 0.1);
}
.cookiesModal .title {
  margin-bottom: 12px;
  font-weight: 800;
  font-size: 20px;
}
.cookiesModal .message {
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 16px;
}
.cookiesModal .accordion {
  border: none;
  border-radius: 5px;
  box-shadow: none;
}
.dark .cookiesModal .accordion {
  background-color: #f2f2f2;
}
.light .cookiesModal .accordion {
  background-color: #f2f2f2;
}
.cookiesModal .accordion:before {
  display: none;
}
.cookiesModal .summary {
  display: flex;
  flex-direction: row-reverse;
  padding: 0px 16px;
}
.cookiesModal .buttonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.titleWrapper {
  display: flex;
  margin-top: 40px !important;
  margin-bottom: 12px !important;
  opacity: 0.8;
}
.titleWrapper:first-child {
  margin-top: 0 !important;
}
.titleWrapper .category {
  margin-right: 6px;
}
.dark .titleWrapper .category {
  color: #4e587f;
}
.light .titleWrapper .category {
  color: #4e587f;
}
.titleWrapper .quantity {
  font-weight: 400;
}
.dark .titleWrapper .quantity {
  color: #7d89b5;
}
.light .titleWrapper .quantity {
  color: #7d89b5;
}

.accordionWrapper {
  margin-bottom: 10px;
}

.accordion {
  padding: 24px !important;
}

.outerWrapper-technis-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 43px;
  height: 43px;
}
.dark .outerWrapper-technis-logo {
  background: #c2cfff;
}
.light .outerWrapper-technis-logo {
  background: #c2cfff;
}
.outerWrapper-technis-logo .generic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.outerWrapper-technis-logo .generic.technisLogo {
  width: 30px;
}
.outerWrapper-technis-logo .generic.organizationLogo {
  width: 43px;
}

.outerWrapper-customer-logo {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 43px;
  height: 43px;
}
.outerWrapper-customer-logo .generic {
  display: flex;
  justify-content: center;
  align-items: center;
}
.outerWrapper-customer-logo .generic.technisLogo {
  width: 30px;
}
.outerWrapper-customer-logo .generic.organizationLogo {
  width: 43px;
}

/**
  Takes a css-key, an optional css-value and a theme-value
  usage : theme("box-shadow", 0 0 30px 5px, "primary") => box-shadow: 0 0 30px 5px primary,
  theme("color", "primary") => color: primary
 */
/* stylelint-disable */
.noData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 250px;
  margin-top: 12px;
  padding: 24px;
  border: 1.5px dashed;
  border-radius: 8px;
}
.dark .noData {
  border-color: #ededf8;
}
.light .noData {
  border-color: #ededf8;
}
.dark .noData {
  background: #f7f7fe;
}
.light .noData {
  background: #f7f7fe;
}
.noData .noDataText {
  margin-top: 32px;
  font-weight: 700;
  font-size: 20px;
  text-align: center;
}
.dark .noData .noDataText {
  color: #4e587f;
}
.light .noData .noDataText {
  color: #4e587f;
}
.noData .noDataSubText {
  margin-top: 24px;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
}
.dark .noData .noDataSubText {
  color: #7d89b5;
}
.light .noData .noDataSubText {
  color: #7d89b5;
}

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* stylelint-disable property-no-unknown */
  font-smoothing: antialiased;
  overflow: hidden;
}
.dark html,
.dark body {
  background: #f5f7fb;
}
.light html,
.light body {
  background: #f7f7fe;
}

@-moz-document url-prefix() {
  body {
    font-weight: lighter !important;
  }
}
html,
body,
#root {
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  font-family: "Inter", sans-serif;
  background-repeat: no-repeat;
  background-attachment: fixed;
}
.dark html,
.dark body,
.dark #root {
  color: rgba(60, 60, 59, 0.8);
}
.light html,
.light body,
.light #root {
  color: rgba(60, 60, 59, 0.8);
}

.wrapper {
  display: flex;
  height: 100vh;
}
.wrapper .main {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 40px;
  overflow: hidden;
}
.wrapper .main.tutorial {
  position: unset;
}
.wrapper .main.helpCenter {
  margin-left: 0;
}
.wrapper .main.overflowHidden {
  overflow-y: hidden;
}
.wrapper .main .topBar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 80px;
  padding-right: 40px;
}
.wrapper .main .topBar .logoContainer {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  max-width: max-content;
  padding-right: 5px;
  padding-left: 5px;
  border-bottom-right-radius: 12px;
  border-bottom-left-radius: 12px;
}
.dark .wrapper .main .topBar .logoContainer {
  background-color: #ffffff;
}
.light .wrapper .main .topBar .logoContainer {
  background-color: #ffffff;
}
.dark .wrapper .main .topBar .logoContainer {
  box-shadow: 0 2px 4px rgba(179, 157, 219, 0.15);
}
.light .wrapper .main .topBar .logoContainer {
  box-shadow: 0 2px 4px rgba(179, 157, 219, 0.15);
}
.wrapper .main .topBar .logo {
  width: auto;
  max-height: 50px;
  margin-right: 10px;
  margin-left: 10px;
}
.wrapper .main .topBar .dropdownWrapper {
  display: flex;
  flex: 0.5;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
  margin-left: 15px;
}
.wrapper .main .topBar .dropdownIcon {
  cursor: pointer;
  transform: rotate(90deg);
}
.wrapper .overflowHidden {
  overflow: hidden;
}

.page-loader {
  padding: 50px 20px;
  text-align: center;
}

.export-container {
  position: absolute;
  top: 0;
  left: 1000%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./styles/theme.scss","webpack://./styles/globalFilters.scss","webpack://./styles/index.scss","webpack://./styles/error.scss","webpack://./styles/parser.scss","webpack://./styles/widget.scss","webpack://./styles/tooltip.scss","webpack://./styles/kpi.module.scss","webpack://./styles/tableGraph.scss","webpack://./styles/skeleton.scss","webpack://./styles/reportGenerator.scss","webpack://./styles/errorBoundary.scss","webpack://./styles/cookiesModal.scss","webpack://./styles/helpCenter.scss","webpack://./styles/logo.scss","webpack://./styles/noData.scss","webpack://./styles/variable.scss"],"names":[],"mappings":"AAuDA;;;;EAAA;AAKA,sBAAA;AC5DA;EACE,gBAAA;EACA,mBAAA;ACQF;;ADLA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;ACOF;;ADJA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ACOF;;ADJA;EACE,YAAA;EAEA,oBAAA;ACMF;;ADHA;EACE,+BAAA;ACMF;;ADHA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;ACMF;;ADHA;EACE,gBAAA;EACA,mBAAA;EACA,kBAAA;ACMF;;ADHA;EACE,UAAA;EAEA,UAAA;EAEA,6BAAA;EAEA,iBAAA;ACGF;;ACvDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;ADyDF;ACvDE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,eAAA;ADwDJ;ACtDI;EACE,eAAA;ADwDN;ACrDI;EACE,gBAAA;ADuDN;ACpDI;EACE,UAAA;EACA,WAAA;ADsDN;ACnDI;EACE,gBAAA;ADqDN;ACjDE;EACE,aAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;ADkDJ;AC7CM;EACE,mBAAA;AD+CR;;AE7FA;EACE,gBAAA;AFgGF;;AGjGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AHoGF;;AGhGE;EACE,SAAA;AHmGJ;;AG/FA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AHkGF;;AG/FA;EACE,kBAAA;EAEA,WAAA;EAEA,mBAAA;AHgGF;AG9FE;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,gBAAA;EACA,mBAAA;AH+FJ;AG7FI;EACE,SAAA;AH+FN;AG3FE;EACE,WAAA;EACA,YAAA;EAEA,eAAA;AH4FJ;AGzFE;EACE,aAAA;EAEA,kBAAA;AH0FJ;AGvFE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,mBAAA;AHwFJ;AGrFE;EACE,aAAA;EAEA,SAAA;EAEA,iBAAA;AHqFJ;AGlFE;EACE,gBAAA;AHoFJ;AGlFI;EACE,gBAAA;EACA,mBAAA;AHoFN;AGjFI;EACE,eAAA;AHmFN;AFhGI;EACE,cAAA;AEkGN;AFnGI;EACE,cAAA;AEqGN;AGpFE;EACE,cAAA;EAEA,WAAA;EACA,cAAA;EAEA,kBAAA;AHoFJ;AGlFI;EACE,eAAA;AHoFN;AGjFI;EACE,WAAA;AHmFN;AGhFI;EACE,gBAAA;EACA,cAAA;EAEA,gBAAA;AHiFN;;AG5EA;EACE,aAAA;AH+EF;;AI1LA;EACE,kBAAA;EACA,QAAA;EAEA,gBAAA;AJ4LF;;AK9LA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ALiMF;AK/LE;EACE,gBAAA;EAEA,gBAAA;EACA,eAAA;ALgMJ;AK7LE;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EAEA,WAAA;AL8LJ;AK5LI;EACE,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,8BAAA;AL6LN;AK3LM;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EAEA,gBAAA;EAEA,iBAAA;EACA,eAAA;EACA,kBAAA;AL2LR;AKzLQ;;EAEE,mBAAA;EACA,uBAAA;EAEA,gBAAA;AL0LV;AKvLQ;EACE,cAAA;ALyLV;AKrLM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;ALqLR;;AMpPA;EACE,wBAAA;ANuPF;AMrPE;EACE,mBAAA;EAEA,iBAAA;ANsPJ;AMnPE;EACE,YAAA;ANqPJ;AMlPE;EACE,YAAA;ANoPJ;AMnPI;EACE,gBAAA;EACA,kBAAA;EAEA,4BAAA;ANoPN;AMjPI;EACE,4BAAA;ANmPN;AMhPI;EACE,gBAAA;EACA,iBAAA;ANkPN;AM9OE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ANgPJ;AM/OI;EACE,YAAA;ANiPN;AM/OI;EACE,4BAAA;ANiPN;AM/OI;EACE,4BAAA;ANiPN;;AO3RE;EACE,sBAAA;AP8RJ;AO3RE;EACE,uBAAA;AP6RJ;AO1RE;EACE,uBAAA;AP4RJ;AOzRE;EACE,YAAA;AP2RJ;AOxRE;EACE,iBAAA;AP0RJ;;AOtRA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EAEA,WAAA;APwRF;AOtRE;EACE,8BAAA;APwRJ;;AOpRA;EACE,gBAAA;APuRF;AOrRE;EACE,iBAAA;APuRJ;AOpRE;EACE,gBAAA;APsRJ;AOnRE;EACE,8BAAA;APqRJ;AOlRE;EACE,oBAAA;APoRJ;AOjRE;EACE,eAAA;APmRJ;;AO/QA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;APkRF;;AO/QA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;APkRF;AOhRE;EACE,gBAAA;EACA,mBAAA;APkRJ;AO/QE;EACE,aAAA;EACA,mBAAA;EAEA,WAAA;APgRJ;AO9QI;EACE,WAAA;APgRN;;AO3QA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AP8QF;AO5QE;EACE,WAAA;AP8QJ;AO5QI;EACE,0BAAA;EAEA,mBAAA;AP6QN;;AOxQA;EACE,mBAAA;AP2QF;;AOxQA;EACE,mBAAA;AP2QF;;AOxQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AP2QF;AOzQE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AP2QJ;AOzQI;EACE,mBAAA;AP2QN;AOxQI;EACE,kBAAA;AP0QN;AOvQI;EACE,kBAAA;APyQN;AOtQI;EACE,kBAAA;APwQN;;AQjZE;EACE,SAAA;EACA,gBAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ARmZJ;AF9VI;EACE,cAAA;AEgWN;AFjWI;EACE,cAAA;AEmWN;AQrZE;EACE,UAAA;EACA,WAAA;EAEA,YAAA;EACA,SAAA;EACA,gBAAA;EAEA,iBAAA;ARqZJ;AF5WI;EACE,mCAAA;AE8WN;AF/WI;EACE,mCAAA;AEiXN;AQvZE;EACE,gBAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;ARwZJ;AF3XI;EACE,cAAA;AE6XN;AF9XI;EACE,cAAA;AEgYN;AQzZE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EAEA,gBAAA;AR0ZJ;AQvZE;EACE,UAAA;EACA,oBAAA;EACA,sBAAA;ARyZJ;AQvZI;EACE,gBAAA;ARyZN;AQrZE;EACE,gBAAA;EAEA,kBAAA;ARsZJ;AQnZE;EACE,aAAA;EACA,uBAAA;EAEA,gBAAA;EACA,mBAAA;ARoZJ;AQlZI;EACE,YAAA;EACA,YAAA;EAEA,kBAAA;ARmZN;AF/ZI;EACE,yBAAA;AEiaN;AFlaI;EACE,yBAAA;AEoaN;AQnZE;EACE,YAAA;ARqZJ;AQnZI;EACE,oBAAA;ARqZN;AQlZI;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;ARoZN;AQjZI;EACE,kBAAA;EACA,oBAAA;ARmZN;AQhZI;EACE,aAAA;ARkZN;AQ/YI;EACE,gBAAA;EACA,kBAAA;ARiZN;AQ7YE;EACE,mBAAA;EAEA,iBAAA;EACA,mBAAA;EAEA,gBAAA;AR6YJ;AFjcI;EACE,mCAAA;AEmcN;AFpcI;EACE,mCAAA;AEscN;AQhZI;EACE,eAAA;ARkZN;;ASzgBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,YAAA;EACA,aAAA;AT0gBF;ASxgBE;EACE,aAAA;EACA,mBAAA;AT0gBJ;ASxgBI;EACE,YAAA;AT0gBN;AStgBE;EACE,mBAAA;ATwgBJ;;AU/hBA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EAEA,aAAA;EACA,sBAAA;EAEA,YAAA;EACA,kBAAA;EAEA,mBAAA;EAEA,6FAAA;AV8hBF;AU5hBE;EACE,mBAAA;EAEA,gBAAA;EACA,eAAA;AV6hBJ;AU1hBE;EACE,mBAAA;EAEA,gBAAA;EACA,eAAA;AV2hBJ;AUxhBE;EACE,YAAA;EACA,kBAAA;EAEA,gBAAA;AVyhBJ;AF5fI;EACE,yBAAA;AE8fN;AF/fI;EACE,yBAAA;AEigBN;AU3hBI;EACE,aAAA;AV6hBN;AUzhBE;EACE,aAAA;EACA,2BAAA;EAEA,iBAAA;AV0hBJ;AUvhBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,gBAAA;AVwhBJ;;AW/kBA;EACE,aAAA;EAEA,2BAAA;EACA,8BAAA;EAEA,YAAA;AXglBF;AW9kBE;EACE,wBAAA;AXglBJ;AW7kBE;EACE,iBAAA;AX+kBJ;AF7hBI;EACE,cAAA;AE+hBN;AFhiBI;EACE,cAAA;AEkiBN;AWjlBE;EACE,gBAAA;AXmlBJ;AFtiBI;EACE,cAAA;AEwiBN;AFziBI;EACE,cAAA;AE2iBN;;AWplBA;EACE,mBAAA;AXulBF;;AWplBA;EACE,wBAAA;AXulBF;;AYzlBA;EAzBE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;AZqnBF;AF5jBI;EACE,mBAAA;AE8jBN;AF/jBI;EACE,mBAAA;AEikBN;AYtnBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AZwnBJ;AYtnBI;EACE,WAAA;AZwnBN;AYrnBI;EACE,WAAA;AZunBN;;AY9mBA;EA7BE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;AZ8oBF;AYzoBE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AZ2oBJ;AYzoBI;EACE,WAAA;AZ2oBN;AYxoBI;EACE,WAAA;AZ0oBN;;AFxmBA;;;;EAAA;AAKA,sBAAA;Ae1DA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EAEA,oBAAA;EACA,kBAAA;AboqBF;AFnnBI;EACE,qBAAA;AEqnBN;AFtnBI;EACE,qBAAA;AEwnBN;AFznBI;EACE,mBAAA;AE2nBN;AF5nBI;EACE,mBAAA;AE8nBN;Aa5qBE;EACE,gBAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;Ab6qBJ;AFroBI;EACE,cAAA;AEuoBN;AFxoBI;EACE,cAAA;AE0oBN;Aa/qBE;EACE,gBAAA;EAEA,gBAAA;EACA,eAAA;EACA,kBAAA;AbgrBJ;AFjpBI;EACE,cAAA;AEmpBN;AFppBI;EACE,cAAA;AEspBN;;AApsBA;EACE,sBAAA;AAusBF;;AApsBA;;EAEE,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,0CAAA;EACA,2BAAA;EAEA,gBAAA;AAssBF;AFrqBI;;EACE,mBAAA;AEwqBN;AFzqBI;;EACE,mBAAA;AE4qBN;;AA1sBA;EACE;IACE,+BAAA;EA6sBF;AACF;AA1sBA;;;EAGE,SAAA;EAEA,gBAAA;EACA,eAAA;EACA,gCAAA;EAEA,4BAAA;EACA,4BAAA;AA0sBF;AFprBI;;;EACE,4BAAA;AEwrBN;AFzrBI;;;EACE,4BAAA;AE6rBN;;AAhtBA;EACE,aAAA;EAEA,aAAA;AAktBF;AAhtBE;EACE,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,kBcwNkB;EdtNlB,gBAAA;AA+sBJ;AA7sBI;EACE,eAAA;AA+sBN;AA5sBI;EACE,cAAA;AA8sBN;AA3sBI;EACE,kBAAA;AA6sBN;AA1sBI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EACA,mBAAA;AA2sBN;AAzsBM;EACE,aAAA;EACA,mBAAA;EAEA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,gCAAA;EACA,+BAAA;AAysBR;AFhvBI;EACE,yBAAA;AEkvBN;AFnvBI;EACE,yBAAA;AEqvBN;AFtvBI;EACE,+CAAA;AEwvBN;AFzvBI;EACE,+CAAA;AE2vBN;AAhtBM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAktBR;AAhtBM;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EAEA,iBAAA;AAitBR;AA/sBM;EACE,eAAA;EAEA,wBAAA;AAgtBR;AA5sBE;EACE,gBAAA;AA8sBJ;;AA1sBA;EACE,kBAAA;EAEA,kBAAA;AA4sBF;;AAzsBA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,WAAA;AA2sBF","sourcesContent":["@import \"variable\";\n\n$themes: (\n  dark: (\n    accordion-background: $gray-light,\n    background: $white-lilac,\n    box-shadow: $gray-30,\n    dropdown-label: $gray,\n    font: $gray-80,\n    helpQuantityColor: $dark-06,\n    helpSectionColor: $dark-04,\n    highlight-color-45: $cold-purple-45,\n    highlight-color: $cold-purple,\n    light: $white,\n    no-data-background: $background-default,\n    no-data-dashed-border: $grey-09,\n    no-data-sub-text: $dark-06,\n    no-data-text: $dark-04,\n    primary-color: $dark-violet,\n    report-generator-border: $gray-10,\n    report-generator-button: $light-blue,\n    report-generator-subtitle: #bbbdc6,\n    report-generator-title: $dark-blue,\n    secondary-color: $deep-lilac,\n    technis-logo-background: $blue-70,\n    top-bar-logo-background-color: $white,\n    top-bar-logo-shadow-color: $cold-purple-15,\n  ),\n  light: (\n    accordion-background: $gray-light,\n    background: $background-default,\n    box-shadow: $gray-30,\n    dropdown-label: $gray,\n    font: $gray-80,\n    helpQuantityColor: $dark-06,\n    helpSectionColor: $dark-04,\n    highlight-color-45: $cold-purple-45,\n    highlight-color: $cold-purple,\n    light: $white,\n    no-data-background: $background-default,\n    no-data-dashed-border: $grey-09,\n    no-data-sub-text: $dark-06,\n    no-data-text: $dark-04,\n    primary-color: $dark-violet,\n    report-generator-border: $gray-10,\n    report-generator-button: $light-blue,\n    report-generator-subtitle: #bbbdc6,\n    report-generator-title: $dark-blue,\n    secondary-color: $deep-lilac,\n    technis-logo-background: $blue-70,\n    top-bar-logo-background-color: $white,\n    top-bar-logo-shadow-color: $cold-purple-15,\n  ),\n);\n\n/**\n  Takes a css-key, an optional css-value and a theme-value\n  usage : theme(\"box-shadow\", 0 0 30px 5px, \"primary\") => box-shadow: 0 0 30px 5px primary,\n  theme(\"color\", \"primary\") => color: primary\n */\n/* stylelint-disable */\n@mixin theme($css-key, $args...) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: if(length($args) == 2, nth($args, 1), null)\n        map-get(map-get($themes, $theme-name), if(length($args) == 2, nth($args, 2), nth($args, 1)));\n    }\n  }\n}\n\n@mixin transparentize($css-key, $theme-color, $transparency: 0) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: transparentize(map-get(map-get($themes, $theme-name), $theme-color), $transparency);\n    }\n  }\n}\n\n@mixin darken($css-key, $theme-color, $transparency: 0) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      #{$css-key}: darken(map-get(map-get($themes, $theme-name), $theme-color), $transparency);\n    }\n  }\n}\n\n@mixin gradient-text($gradient-fonts) {\n  @each $theme-name, $color in $themes {\n    .#{$theme-name} & {\n      $gradients: map-get(map-get($themes, $theme-name), $gradient-fonts);\n      color: transparent;\n\n      background-image: linear-gradient(nth($gradients, 1), nth($gradients, 2));\n      -webkit-background-clip: text;\n    }\n  }\n}\n",".categoryFilter {\n  margin-top: 30px;\n  padding-right: 50px;\n}\n\n.segmentedControl {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: baseline;\n\n  margin-top: 30px;\n  margin-right: 50px;\n  padding-right: 20px;\n  padding-left: 12px;\n}\n\n.dateFilter {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.dateFilterDisabled {\n  opacity: 0.6;\n\n  pointer-events: none;\n}\n\n.dateFilterLabel {\n  font-family: \"Lato\", sans-serif;\n}\n\n.dateInputWrapper {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.genderFilter {\n  margin-top: 20px;\n  padding-right: 50px;\n  padding-left: 12px;\n}\n\n.calendarDropdown.calendarDropdown {\n  z-index: 5;\n\n  padding: 0;\n\n  background-color: transparent;\n\n  box-shadow: unset;\n}\n","@import \"variable\";\n@import \"theme\";\n@import \"globalFilters\";\n@import \"error\";\n@import \"parser\";\n@import \"widget\";\n@import \"tooltip\";\n@import \"kpi.module\";\n@import \"tableGraph\";\n@import \"skeleton\";\n@import \"reportGenerator\";\n@import \"errorBoundary\";\n@import \"cookiesModal\";\n@import url(\"https://rsms.me/inter/inter.css\");\n@import \"helpCenter\";\n@import \"logo\";\n@import \"noData\";\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  /* stylelint-disable property-no-unknown */\n  font-smoothing: antialiased;\n\n  overflow: hidden;\n  @include theme(\"background\", \"background\");\n}\n\n@-moz-document url-prefix() {\n  body {\n    font-weight: lighter !important;\n  }\n}\n\nhtml,\nbody,\n#root {\n  margin: 0;\n\n  font-weight: 400;\n  font-size: 16px;\n  font-family: \"Inter\", sans-serif;\n\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  @include transparentize(\"color\", \"font\");\n}\n\n.wrapper {\n  display: flex;\n\n  height: 100vh;\n\n  .main {\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n\n    padding-left: $main-layout-padding;\n\n    overflow: hidden;\n\n    &.tutorial {\n      position: unset;\n    }\n\n    &.helpCenter {\n      margin-left: 0;\n    }\n\n    &.overflowHidden {\n      overflow-y: hidden;\n    }\n\n    .topBar {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n\n      width: 100%;\n      height: 80px;\n      padding-right: 40px;\n\n      .logoContainer {\n        display: flex;\n        align-items: center;\n\n        width: 100%;\n        height: 100%;\n        max-width: max-content;\n        padding-right: 5px;\n        padding-left: 5px;\n\n        border-bottom-right-radius: 12px;\n        border-bottom-left-radius: 12px;\n\n        @include theme(\"background-color\", \"top-bar-logo-background-color\");\n        @include theme(\"box-shadow\", 0 2px 4px, \"top-bar-logo-shadow-color\");\n      }\n      .logo {\n        width: auto;\n        max-height: 50px;\n        margin-right: 10px;\n        margin-left: 10px;\n      }\n      .dropdownWrapper {\n        display: flex;\n        flex: 0.5;\n        gap: 10px;\n        justify-content: flex-end;\n        align-items: center;\n\n        margin-left: 15px;\n      }\n      .dropdownIcon {\n        cursor: pointer;\n\n        transform: rotate(90deg);\n      }\n    }\n  }\n  .overflowHidden {\n    overflow: hidden;\n  }\n}\n\n.page-loader {\n  padding: 50px 20px;\n\n  text-align: center;\n}\n\n.export-container {\n  position: absolute;\n  top: 0;\n  left: 1000%;\n\n  width: 100%;\n}\n",".error-template {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  margin-top: 5em;\n  margin-bottom: 1em;\n\n  .error-number {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n    font-weight: 800;\n    font-size: 42px;\n\n    &.has-technis-logo {\n      max-width: 12em;\n    }\n\n    &:not(.has-technis-logo) {\n      line-height: 0.8;\n    }\n\n    .technis-logo {\n      width: 40%;\n      height: 40%;\n    }\n\n    .normal-error-code {\n      font-size: 120px;\n    }\n  }\n\n  .error-message {\n    margin: 1em 0;\n\n    font-weight: 300;\n    font-size: 28px;\n    text-align: center;\n  }\n\n  .buttons {\n    button {\n      &:not(:last-child) {\n        margin-right: 0.5em;\n      }\n    }\n  }\n}\n",".tooltip-bold {\n  font-weight: 700;\n}\n",".widgetWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.tooltipWrapper {\n  p {\n    margin: 0;\n  }\n}\n\n.tooltipContent {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.widget {\n  position: relative;\n\n  width: 100%;\n\n  border-radius: 12px;\n\n  &__export {\n    position: absolute;\n    top: 0;\n    right: 30px;\n\n    margin-top: 15px;\n    margin-bottom: 15px;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  &__image {\n    width: 26px;\n    height: 26px;\n\n    cursor: pointer;\n  }\n\n  &__loader {\n    padding: 30px;\n\n    text-align: center;\n  }\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    margin-bottom: 10px;\n  }\n\n  & &__title {\n    display: flex;\n\n    margin: 0;\n\n    font-weight: bold;\n  }\n\n  .mapView-container {\n    margin-top: 15px;\n\n    .dropdown {\n      max-width: 200px;\n      margin-bottom: 15px;\n    }\n\n    label {\n      font-size: 12px;\n      @include theme(\"color\", \"dropdown-label\");\n    }\n  }\n\n  .heatmap {\n    display: block;\n\n    width: 100%;\n    margin: 0 auto;\n\n    text-align: center;\n\n    &__image {\n      max-width: 100%;\n    }\n\n    &__carousel {\n      width: 100%;\n    }\n\n    .dropdown {\n      max-width: 200px;\n      margin: 15px 0;\n\n      text-align: left;\n    }\n  }\n}\n\n.widgetTitleWrapper {\n  display: flex;\n}\n",".tooltipWrapper {\n  position: relative;\n  top: 1px;\n\n  margin-left: 5px;\n}\n","@import \"variable\";\n\n.kpiCardWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n\n  .kpiSubTitle {\n    margin-top: 30px;\n\n    font-weight: 800;\n    font-size: 24px;\n  }\n\n  .kpiCardContainer {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(254px, 1fr));\n    gap: 16px;\n\n    width: 100%;\n\n    .kpiCard {\n      height: 180px;\n      min-width: 170px;\n      max-width: 218px;\n      margin: 10px 26px;\n\n      border-radius: 12px !important;\n\n      .kpiFirstLine {\n        display: flex;\n        gap: 10px;\n        justify-content: center;\n\n        margin-top: 24px;\n\n        font-weight: bold;\n        font-size: 28px;\n        text-align: center;\n\n        > div,\n        [data-for] {\n          white-space: nowrap;\n          text-overflow: ellipsis;\n\n          overflow: hidden;\n        }\n\n        svg {\n          flex: 0 0 32px;\n        }\n      }\n\n      .kpiSecondLine {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        height: 15px;\n        margin-top: 52px;\n\n        font-weight: 500;\n        font-size: 20px;\n        text-align: center;\n      }\n    }\n  }\n}\n",".table-graph-container {\n  padding: 5px 10px 0 10px;\n\n  .table-line {\n    margin-bottom: 20px;\n\n    border: 1px solid;\n  }\n\n  .table-graph-head {\n    border: none;\n  }\n\n  .table-header {\n    border: none;\n    td:first-child {\n      min-width: 230px;\n      padding-left: 25px;\n\n      border-radius: 12px 0 0 12px;\n    }\n\n    td:last-child {\n      border-radius: 0 12px 12px 0;\n    }\n\n    div {\n      font-weight: 600;\n      line-height: 22px;\n    }\n  }\n\n  .table-row {\n    font-weight: 500;\n    font-size: 18px;\n    line-height: 19px;\n    tr:first-child {\n      border: none;\n    }\n    td:first-child {\n      border-radius: 12px 0 0 12px;\n    }\n    td:last-child {\n      border-radius: 0 12px 12px 0;\n    }\n  }\n}\n",".widget__loader {\n  &--table {\n    padding: 6px 30px 30px;\n  }\n\n  &--pie {\n    padding: 40px 30px 20px;\n  }\n\n  &--chart {\n    padding: 30px 30px 20px;\n  }\n\n  &--no-pad {\n    padding: 0px;\n  }\n\n  &--grid-map {\n    padding: 29px 9px;\n  }\n}\n\n.kpiCardSkeletonContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(254px, 1fr));\n  gap: 16px;\n\n  width: 100%;\n\n  .skeletonKpi {\n    border-radius: 12px !important;\n  }\n}\n\n.skeletonTableWrapper {\n  margin-left: 8px;\n\n  .skeletonTableLine {\n    border: 1px solid;\n  }\n\n  .skeletonTableHeaderWrapper {\n    margin-top: 22px;\n  }\n\n  .skeletonTableHeader {\n    border-radius: 12px !important;\n  }\n\n  .skeletonTableRowWrapper {\n    margin-bottom: -25px;\n  }\n\n  .skeletonTableRow {\n    margin-top: 7px;\n  }\n}\n\n.skeletonWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.chartSkeletonWrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  .legendGradientContainer {\n    margin-top: 35px;\n    margin-bottom: 13px;\n  }\n\n  .chartSkeletonContainer {\n    display: flex;\n    flex-direction: row;\n\n    width: 100%;\n\n    .chartItem {\n      margin: 2px;\n    }\n  }\n}\n\n.skeletonMapViewWrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n\n  .skeletonLinesWrapper {\n    width: 100%;\n\n    span {\n      margin: 10px 0px 10px 30px;\n\n      border-radius: 50px;\n    }\n  }\n}\n\n.skeletonPieChart {\n  margin-bottom: 30px;\n}\n\n.skeletonLineAreaChart {\n  margin-bottom: 35px;\n}\n\n.legend {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n\n  .legendItem {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n\n    span {\n      border-radius: 50px;\n    }\n\n    .legendCircle {\n      margin-right: 10px;\n    }\n\n    .legendText {\n      margin-right: 25px;\n    }\n\n    .legendGradient {\n      border-radius: 0px;\n    }\n  }\n}\n",".report-card {\n  .report-card-title {\n    margin: 0;\n    padding-top: 5px;\n\n    font-weight: 700;\n    font-size: 36px;\n    font-style: normal;\n    line-height: 44px;\n    letter-spacing: 0;\n    text-align: center;\n    @include theme(\"color\", \"report-generator-title\");\n  }\n\n  .report-card-line {\n    top: 592px;\n    left: 421px;\n\n    width: 837px;\n    height: 0;\n    margin-top: 18px;\n\n    border: 1px solid;\n    @include theme(\"border-color\", \"report-generator-border\");\n  }\n\n  .report-card-subtext {\n    margin-top: 10px;\n\n    font-weight: 400;\n    font-size: 12px;\n    font-style: normal;\n    line-height: 14px;\n    letter-spacing: 0;\n    text-align: center;\n\n    @include theme(\"color\", \"report-generator-subtitle\");\n  }\n\n  .report-card-form-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    margin-top: 36px;\n  }\n\n  .report-card-form-block {\n    width: 40%;\n    padding: 0 22px 32px;\n    box-sizing: border-box;\n\n    .report-card-form-emails {\n      margin-top: 40px;\n    }\n  }\n\n  .report-card-bottom-subtitle {\n    margin-top: 30px;\n\n    text-align: center;\n  }\n\n  .report-card-button-wrapper {\n    display: flex;\n    justify-content: center;\n\n    margin-top: 16px;\n    margin-bottom: 33px;\n\n    .report-card-button {\n      width: 140px;\n      height: 34px;\n\n      border-radius: 8px;\n\n      @include theme(\"background-color\", \"report-generator-button\");\n    }\n  }\n\n  .dropdown-wrapper {\n    padding: 3px;\n\n    .Dropdown__value-container {\n      margin-bottom: -15px;\n    }\n\n    .Dropdown__single-value {\n      font-size: 14px;\n      font-style: italic;\n      line-height: 18px;\n    }\n\n    .Dropdown__indicator {\n      margin-right: -5px;\n      margin-bottom: -10px;\n    }\n\n    .Dropdown__indicator-separator {\n      display: none;\n    }\n\n    .Dropdown__control {\n      margin-top: -8px;\n      margin-bottom: 8px;\n    }\n  }\n\n  .card-wrapper {\n    padding-right: 20px;\n\n    border: 1px solid;\n    border-radius: 12px;\n\n    box-shadow: none;\n    @include theme(\"border-color\", \"report-generator-border\");\n\n    h3 {\n      font-size: 14px;\n    }\n  }\n}\n",".errorBoundary {\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 100vw;\n  height: 100vh;\n\n  &--buttons {\n    display: flex;\n    align-items: center;\n\n    button {\n      margin: 15px;\n    }\n  }\n\n  h1 {\n    margin-bottom: 50px;\n  }\n}\n",".cookiesModal {\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  z-index: 999;\n\n  display: flex;\n  flex-direction: column;\n\n  width: 535px;\n  padding: 32px 48px;\n\n  border-radius: 10px;\n\n  box-shadow: 2px 2px 20px rgba(115, 115, 115, 0.1), 2px 10px 50px 3px rgba(112, 112, 224, 0.1);\n\n  .title {\n    margin-bottom: 12px;\n\n    font-weight: 800;\n    font-size: 20px;\n  }\n\n  .message {\n    margin-bottom: 20px;\n\n    font-weight: 400;\n    font-size: 16px;\n  }\n\n  .accordion {\n    border: none;\n    border-radius: 5px;\n\n    box-shadow: none;\n\n    @include theme(\"background-color\", \"accordion-background\");\n\n    &:before {\n      display: none;\n    }\n  }\n\n  .summary {\n    display: flex;\n    flex-direction: row-reverse;\n\n    padding: 0px 16px;\n  }\n\n  .buttonContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    margin-top: 20px;\n  }\n}\n",".titleWrapper {\n  display: flex;\n\n  margin-top: 40px !important;\n  margin-bottom: 12px !important;\n\n  opacity: 0.8;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n\n  .category {\n    margin-right: 6px;\n    @include theme(\"color\", \"helpSectionColor\");\n  }\n\n  .quantity {\n    font-weight: 400;\n    @include theme(\"color\", \"helpQuantityColor\");\n  }\n}\n\n.accordionWrapper {\n  margin-bottom: 10px;\n}\n\n.accordion {\n  padding: 24px !important;\n}\n","@mixin get-outer-wrapper($isTechnisLogo: true) {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 43px;\n  height: 43px;\n  @if $isTechnisLogo {\n    @include theme(\"background\", \"technis-logo-background\");\n  }\n\n  .generic {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &.technisLogo {\n      width: 30px;\n    }\n\n    &.organizationLogo {\n      width: 43px;\n    }\n  }\n}\n\n.outerWrapper-technis-logo {\n  @include get-outer-wrapper();\n}\n\n.outerWrapper-customer-logo {\n  @include get-outer-wrapper(false);\n}\n","@use \"theme\";\n\n.noData {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  width: 100%;\n  min-height: 250px;\n  margin-top: 12px;\n  padding: 24px;\n\n  border: 1.5px dashed;\n  border-radius: 8px;\n  @include theme(\"border-color\", \"no-data-dashed-border\");\n  @include theme(\"background\", \"no-data-background\");\n\n  .noDataText {\n    margin-top: 32px;\n\n    font-weight: 700;\n    font-size: 20px;\n    text-align: center;\n    @include theme(\"color\", \"no-data-text\");\n  }\n\n  .noDataSubText {\n    margin-top: 24px;\n\n    font-weight: 400;\n    font-size: 16px;\n    text-align: center;\n    @include theme(\"color\", \"no-data-sub-text\");\n  }\n}\n","// Common colors\n$white: #ffffff;\n$black: #000000;\n\n// Default colors\n$primary-default: #3e7bfa;\n$background-default: #f7f7fe;\n\n// Named colors\n$primary-50: #3e67fa;\n$primary-50-30: #e6ebfe;\n\n// Tints of black/white\n$gray: #3c3c3b;\n$gray-80: rgba($gray, 0.8);\n$gray-60: rgba($gray, 0.6);\n$gray-30: rgba($gray, 0.3);\n$gray-10: rgba($gray, 0.1);\n$gray-light: #f2f2f2;\n\n$light-01: #f7faff;\n$light-02: #f7f7fc;\n$light-04: #e5e5f6;\n\n$dark-06: #7d89b5;\n\n// Old colors\n$old-base-30: #4b4d73;\n$old-base-40: #8a8dba;\n$old-base-80: #f7f7fc;\n\n// Colors\n$dark-blue: #4153af;\n$light-blue: #588de7;\n$blue: #005aee;\n$blue-70: #c2cfff;\n$electric-violet: #4c00ee;\n$purple: #8f4dea;\n$white-lilac: #f5f7fb;\n$deep-lilac: #7e57c2;\n$dark-violet: #363670;\n$cold-purple: #b39ddb;\n$cold-purple-15: rgba($cold-purple, 0.15);\n$cold-purple-45: rgba($cold-purple, 0.45);\n\n// Exported from Figma\n$accent-blue-default: #00dee7;\n$accent-blue-light: #a1fcff;\n$accent-blue-lighter: #e5fdff;\n$accent-green-default: #70df9e;\n$accent-green-light: #a5e7c0;\n$accent-green-lighter: #ebfff3;\n$accent-orange-default: #fe7e6d;\n$accent-orange-light: #ffa59a;\n$accent-orange-lighter: #ffefe7;\n$accent-purple-default: #775ffc;\n$accent-purple-light: #a89aff;\n$accent-purple-lighter: #e7e7ff;\n$accent-red-default: #fe6470;\n$accent-red-default-30: #ffc7c74d;\n$accent-red-light: #ff9aa1;\n$accent-red-lighter: #ffe0e2;\n$accent-yellow-default: #ffcc77;\n$accent-yellow-light: #ffdda5;\n$accent-yellow-lighter: #fffce9;\n$background-dark-bis: #31374f;\n$background-dark: #28283d;\n$background-light: #f6f6fd;\n$dark-01: #14161f;\n$dark-02: #272c3f;\n$dark-03: #3a425e;\n$dark-04: #4e587f;\n$dark-05: #606e9e;\n$grey-01: #383854;\n$grey-02: #565676;\n$grey-03: #6e6e91;\n$grey-04: #8c8caf;\n$grey-05: #aaaac9;\n$grey-06: #bcbcd7;\n$grey-07: #d0d0e6;\n$grey-08: #e5e5f5;\n$grey-09: #ededf8;\n$grey-10: #f6f6fd;\n$highlight-default: #ffcc77;\n$highlight-light: #fffce9;\n$light-01: #ffffff;\n$light-02: #d9def2;\n$light-03: #bac1de;\n$light-04: #9da6c7;\n$light-05: #7d89b4;\n$primary-01: #202244;\n$primary-02: #2b3458;\n$primary-03: #324aa1;\n$primary-04: #2b4fcf;\n$primary-05: #3e66fa;\n$primary-06: #7995fa;\n$primary-07: #c1cfff;\n$primary-08: #e0e7ff;\n$primary-09: #edf1ff;\n$primary-10: #f4f7ff;\n$secondary-50: #ffa59a;\n$secondary-darker: #e57162;\n$secondary-default: #fe7e6d;\n$secondary-disabled: #fdd7cb;\n$secondary-light: #fff0e9;\n$secondary-lighter: #fff9f7;\n$status-error-50: #ff8d8d;\n$status-error-default: #ff6060;\n$status-error-light: #ffc6c6;\n$status-error-lighter: #fff2f2;\n$status-success-50: #86f1bc;\n$status-success-dark: #2b4c4c;\n$status-success-default: #39d98a;\n$status-success-default-30: #c8ffe44d;\n$status-success-light: #c8ffe4;\n$status-success-lighter: #e9fff4;\n$status-warning-50: #ffd687;\n$status-warning-default: #ffc961;\n$status-warning-light: #ffe8bb;\n$status-warning-lighter: #fff7e9;\n$text-01: #14161f;\n$text-02: #272c3f;\n$text-03: #3a425e;\n$text-04: #4e587f;\n$text-05: #606e9e;\n$text-06: #7d89b4;\n$text-07: #9da6c7;\n$text-08: #bac1de;\n$text-09: #d9def2;\n$widgets-blue-187-01: #144e56;\n$widgets-blue-187-02: #167b89;\n$widgets-blue-187-03: #31aaba;\n$widgets-blue-187-04: #5ad7e8;\n$widgets-blue-187-05: #89f1ff;\n$widgets-blue-187-06: #c8f6fd;\n$widgets-blue-187-07: #e6fcff;\n$widgets-blue-187-08: #fcfeff;\n$widgets-blue-207-01: #143856;\n$widgets-blue-207-02: #165589;\n$widgets-blue-207-03: #317cba;\n$widgets-blue-207-04: #5aaae8;\n$widgets-blue-207-05: #89caff;\n$widgets-blue-207-06: #c8e5fd;\n$widgets-blue-207-07: #e6f3ff;\n$widgets-blue-207-08: #fcfeff;\n$widgets-blue-227-01: #142256;\n$widgets-blue-227-02: #172f89;\n$widgets-blue-227-03: #314eba;\n$widgets-blue-227-04: #5b7de8;\n$widgets-blue-227-05: #89a3ff;\n$widgets-blue-227-06: #c8d3fd;\n$widgets-blue-227-07: #e6ebff;\n$widgets-blue-227-08: #fcfdff;\n$widgets-blue-247-01: #1c1456;\n$widgets-blue-247-02: #241689;\n$widgets-blue-247-03: #4131ba;\n$widgets-blue-247-04: #6b5ae8;\n$widgets-blue-247-05: #9789ff;\n$widgets-blue-247-06: #cec8fd;\n$widgets-blue-247-07: #e8e6ff;\n$widgets-blue-247-08: #fdfcff;\n$widgets-brown-17-01: #562714;\n$widgets-brown-17-02: #893716;\n$widgets-brown-17-03: #ba5831;\n$widgets-brown-17-04: #e8825a;\n$widgets-brown-17-05: #ffaa89;\n$widgets-brown-17-06: #fdd7c8;\n$widgets-brown-17-07: #ffede6;\n$widgets-brown-17-08: #fffdfc;\n$widgets-green-127-01: #14561c;\n$widgets-green-127-02: #168924;\n$widgets-green-127-03: #31ba41;\n$widgets-green-127-04: #5ae86b;\n$widgets-green-127-05: #89ff97;\n$widgets-green-127-06: #c8fdce;\n$widgets-green-127-07: #e6ffe8;\n$widgets-green-127-08: #fcfffd;\n$widgets-green-147-01: #145632;\n$widgets-green-147-02: #16894a;\n$widgets-green-147-03: #31ba6f;\n$widgets-green-147-04: #5ae89a;\n$widgets-green-147-05: #89ffbe;\n$widgets-green-147-06: #c8fddf;\n$widgets-green-147-07: #e6fff1;\n$widgets-green-147-08: #fcfffd;\n$widgets-green-167-01: #145648;\n$widgets-green-167-02: #168970;\n$widgets-green-167-03: #31ba9c;\n$widgets-green-167-04: #5ae8c9;\n$widgets-green-167-05: #89ffe5;\n$widgets-green-167-06: #c8fdf1;\n$widgets-green-167-07: #e6fff9;\n$widgets-green-167-08: #fcfffe;\n$widgets-green-67-01: #4e5614;\n$widgets-green-67-02: #7b8916;\n$widgets-green-67-03: #aaba31;\n$widgets-green-67-04: #d7e85a;\n$widgets-green-67-05: #f1ff89;\n$widgets-green-67-06: #edfdc8;\n$widgets-green-67-07: #fcffe6;\n$widgets-green-67-08: #fefffc;\n$widgets-green-97-01: #2d5614;\n$widgets-green-97-02: #428916;\n$widgets-green-97-03: #65ba31;\n$widgets-green-97-04: #91e85a;\n$widgets-green-97-05: #b6ff89;\n$widgets-green-97-06: #d3fdc8;\n$widgets-green-97-07: #efffe6;\n$widgets-green-97-08: #fdfffc;\n$widgets-orange-27-01: #563214;\n$widgets-orange-27-02: #894a16;\n$widgets-orange-27-03: #ba6f31;\n$widgets-orange-27-04: #e89a5a;\n$widgets-orange-27-05: #ffbe89;\n$widgets-orange-27-06: #fddfc8;\n$widgets-orange-27-07: #fff1e6;\n$widgets-orange-27-08: #fffdfc;\n$widgets-pink-307-01: #56144e;\n$widgets-pink-307-02: #89167b;\n$widgets-pink-307-03: #ba31aa;\n$widgets-pink-307-04: #e85ad7;\n$widgets-pink-307-05: #ff89f1;\n$widgets-pink-307-06: #fdc8f6;\n$widgets-pink-307-07: #ffe6fc;\n$widgets-pink-307-08: #fffcfe;\n$widgets-pink-327-01: #561438;\n$widgets-pink-327-02: #891655;\n$widgets-pink-327-03: #ba317c;\n$widgets-pink-327-04: #e85aa8;\n$widgets-pink-327-05: #ff89ca;\n$widgets-pink-327-06: #fdc8e5;\n$widgets-pink-327-07: #ffe6f3;\n$widgets-pink-327-08: #fffcfe;\n$widgets-pink-347-01: #561423;\n$widgets-pink-347-02: #89162f;\n$widgets-pink-347-03: #ba314e;\n$widgets-pink-347-04: #e85a79;\n$widgets-pink-347-05: #ff89a3;\n$widgets-pink-347-06: #fdc8d3;\n$widgets-pink-347-07: #ffe6eb;\n$widgets-pink-347-08: #fffcfd;\n$widgets-purple-267-01: #321456;\n$widgets-purple-267-02: #4a1689;\n$widgets-purple-267-03: #6f31ba;\n$widgets-purple-267-04: #9a5ae8;\n$widgets-purple-267-05: #be89ff;\n$widgets-purple-267-06: #dfc8fd;\n$widgets-purple-267-07: #f1e6ff;\n$widgets-purple-267-08: #fdfcff;\n$widgets-purple-287-01: #481456;\n$widgets-purple-287-02: #701689;\n$widgets-purple-287-03: #9c31ba;\n$widgets-purple-287-04: #c95ae8;\n$widgets-purple-287-05: #e589ff;\n$widgets-purple-287-06: #f1c8fd;\n$widgets-purple-287-07: #f9e6ff;\n$widgets-purple-287-08: #fefcff;\n$widgets-red-360-01: #561414;\n$widgets-red-360-02: #891617;\n$widgets-red-360-03: #ba3131;\n$widgets-red-360-04: #e85a5b;\n$widgets-red-360-05: #ff8989;\n$widgets-red-360-06: #fdc8c8;\n$widgets-red-360-07: #ffe6e6;\n$widgets-red-360-08: #fffcfc;\n$widgets-yellow-37-01: #563d14;\n$widgets-yellow-37-02: #895d16;\n$widgets-yellow-37-03: #ba8531;\n$widgets-yellow-37-04: #e8b15a;\n$widgets-yellow-37-05: #ffd289;\n$widgets-yellow-37-06: #fde8c8;\n$widgets-yellow-37-07: #fff5e6;\n$widgets-yellow-37-08: #fffefc;\n$widgets-yellow-47-01: #564814;\n$widgets-yellow-47-02: #897016;\n$widgets-yellow-47-03: #ba9c31;\n$widgets-yellow-47-04: #e8c95a;\n$widgets-yellow-47-05-1: #fdf1c8;\n$widgets-yellow-47-05: #ffe589;\n$widgets-yellow-47-07: #fff9e6;\n$widgets-yellow-47-08: #fffefc;\n\n$main-layout-padding: 40px;\n\n// Settings table styles\n$settings-table--last-column-min-width: 115px;\n$settings-table-last-column-width: 30%;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
